<template>
  <div class="new-apply-invoice" v-loading="loading">
    <div class="page-title">开具发票</div>

    <div class="content-card">
      <el-form label-width="100px" class="invoice-form">
        <el-form-item label="发票抬头" :required="true">
          <el-radio-group v-model="invoiceType" @change="handleTypeChange">
            <el-radio label="0">医院单位</el-radio>
            <el-radio label="1">个人</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item :label="invoiceType === '0' ? '单位名称' : '个人名称'" :required="true">
          <el-input
            v-model.trim="invoiceHeader"
            :disabled="invoiceType === '1'"
            :placeholder="'请填写' + (invoiceType === '0' ? '单位名称' : '个人名称')"
          ></el-input>
        </el-form-item>

        <el-form-item v-if="invoiceType === '0'" label="纳税识别号" :required="true">
          <el-input v-model.trim="taxNo" placeholder="请填写纳税人识别号"></el-input>
        </el-form-item>

        <el-form-item label="收票人邮箱" :required="true">
          <el-input v-model.trim="email" placeholder="请填写收票人邮箱"></el-input>
        </el-form-item>

        <el-divider v-if="invoiceType === '0'" content-position="center">更多内容(选填)</el-divider>

        <el-form-item v-if="invoiceType === '0'" label="注册地址">
          <el-input v-model.trim="address" placeholder="请填写注册地址"></el-input>
        </el-form-item>

        <el-form-item v-if="invoiceType === '0'" label="注册电话">
          <el-input v-model.trim="telephone" placeholder="请填写注册电话"></el-input>
        </el-form-item>

        <el-form-item v-if="invoiceType === '0'" label="开户银行">
          <el-input v-model.trim="bankName" placeholder="请填写开户银行"></el-input>
        </el-form-item>

        <el-form-item v-if="invoiceType === '0'" label="银行账号">
          <el-input v-model.trim="bankNo" placeholder="请填写银行账号"></el-input>
        </el-form-item>

        <el-form-item label="开票金额">
          <span class="amount">{{ displayPrice }}元</span>
        </el-form-item>

        <el-form-item label="发票内容">
          <span class="content-text">{{ content }}</span>
        </el-form-item>
      </el-form>

      <div class="submit-wrap">
        <el-button
          type="primary"
          class="submit-btn"
          :loading="isSubmitting"
          @click="handleNextStep"
        >
          下一步
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  name: "NewApplyInvoice",
  REG_EXAM_NAV_STATE_KEY: "reg_exam_nav_state",
  data() {
    return {
      loading: false,
      isSubmitting: false,
      invoiceType: "1",
      invoiceHeader: "个人",
      taxNo: "",
      email: "",
      address: "",
      telephone: "",
      bankName: "",
      bankNo: "",
      serverMoney: null,
      content: "*非学历教育内容*培训费"
    };
  },
  computed: {
    erId() {
      const value = Number(this.$route.query.erId);
      return Number.isNaN(value) ? 0 : value;
    },
    rawPrice() {
      const value = Number(this.$route.query.price);
      return Number.isNaN(value) ? 0 : value;
    },
    finalPriceValue() {
      if (this.rawPrice > 0) {
        return this.rawPrice;
      }
      const serverMoney = Number(this.serverMoney);
      return Number.isNaN(serverMoney) ? 0 : serverMoney;
    },
    displayPrice() {
      return this.formatPrice(this.finalPriceValue);
    }
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.initPage();
      }
    }
  },
  created() {
    this.initPage();
  },
  methods: {
    async initPage() {
      if (!this.erId) {
        this.$message.error("报名参数异常");
        return;
      }

      this.applyDefaultType();
      this.loading = true;
      try {
        await this.loadSavedInvoice();
      } finally {
        this.loading = false;
      }
    },
    applyDefaultType() {
      if (String(this.$route.query.ismine) === "1") {
        this.invoiceType = "1";
        this.invoiceHeader = "个人";
      } else {
        this.invoiceType = "0";
        this.invoiceHeader = "";
      }
    },
    handleTypeChange() {
      if (this.invoiceType === "1") {
        this.invoiceHeader = "个人";
        this.taxNo = "";
      } else if (this.invoiceHeader === "个人") {
        this.invoiceHeader = "";
      }
    },
    async loadSavedInvoice() {
      const res = await httpRequest("/app/invoice/invoice/invoice", "get", {
        erId: this.erId
      });
      if (!res || res.code !== 200) {
        return;
      }

      const data = res.data;
      if (!data) {
        return;
      }

      if (data.money !== null && data.money !== undefined) {
        this.serverMoney = data.money;
      }
      if (data.invoiceType !== undefined && data.invoiceType !== null) {
        this.invoiceType = String(data.invoiceType);
      }
      this.invoiceHeader = data.companyName || data.personName || this.invoiceHeader;
      this.taxNo = data.dutyParagraph || "";
      this.email = data.email || "";
      this.address = data.address || "";
      this.telephone = data.phone || "";
      this.bankName = data.bankName || "";
      this.bankNo = data.bankAccount || "";
      if (data.content) {
        this.content = data.content.indexOf("*") >= 0 ? data.content : `*非学历教育内容*${data.content}`;
      }
      this.handleTypeChange();
    },
    validateForm() {
      if (!this.invoiceHeader) {
        this.$message.warning(`请填写${this.invoiceType === "0" ? "单位名称" : "个人名称"}`);
        return false;
      }
      if (this.invoiceType === "0" && !this.taxNo) {
        this.$message.warning("请填写纳税人识别号");
        return false;
      }
      if (!this.email) {
        this.$message.warning("请填写收票人邮箱");
        return false;
      }
      return true;
    },
    async handleNextStep() {
      if (this.isSubmitting || !this.validateForm()) {
        return;
      }
      this.isSubmitting = true;
      try {
        const supplyParams = {
          invoiceType: this.invoiceType,
          personName: this.invoiceHeader,
          companyName: this.invoiceHeader,
          dutyParagraph: this.taxNo,
          address: this.address,
          phone: this.telephone,
          bankName: this.bankName,
          bankAccount: this.bankNo,
          money: this.finalPriceValue,
          email: this.email,
          erId: this.erId
        };
        const supplyRes = await httpRequest(
          "/app/invoice/invoice/supplyInvoice",
          "post",
          supplyParams
        );
        if (!supplyRes || supplyRes.code !== 200) {
          this.$message.error((supplyRes && supplyRes.message) || "提交发票信息失败");
          return;
        }

        const applyRes = await httpRequest("/app/exam/apply", "post", {
          erId: this.erId
        });
        if (!applyRes || applyRes.code !== 200) {
          this.$message.error((applyRes && applyRes.message) || "报名失败");
          return;
        }

        const regExamNavState = {
          erId: this.erId,
          skipPrivacy: true,
          ts: Date.now()
        };
        try {
          sessionStorage.setItem(
            this.$options.REG_EXAM_NAV_STATE_KEY,
            JSON.stringify(regExamNavState)
          );
        } catch (e) {
          void e;
        }
        this.$router.push({
          name: "RegExam",
          params: {
            erId: String(this.erId),
            skipPrivacy: "1"
          }
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    formatPrice(value) {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return "0";
      }
      if (Number.isInteger(num)) {
        return String(num);
      }
      return num.toFixed(2).replace(/\.00$/, "");
    }
  }
};
</script>

<style scoped lang="scss">
.new-apply-invoice {
  min-height: calc(100vh - 67px - 100px);
  width: 1200px;
  margin: 16px auto 0;
  background: #f5f6f8;
  padding: 20px 22px 28px;
  box-sizing: border-box;

  .page-title {
    text-align: center;
    color: #3f8eea;
    font-size: 58px;
    font-weight: 700;
    line-height: 1;
    transform: scale(0.48);
    transform-origin: center center;
    margin-bottom: 16px;
  }

  .content-card {
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 10px 24px rgba(27, 48, 86, 0.08);
    padding: 26px 24px 30px;
  }

  .invoice-form {
    text-align: left;
    margin: 0 40px;

    .el-form-item {
      border-bottom: 1px dashed #e4e8ef;
      margin-bottom: 16px;
      padding-bottom: 10px;
    }

    .el-form-item__content {
      padding-left: 4px;
    }

    .amount {
      color: #4d5460;
      font-size: 30px;
      transform: scale(0.5);
      display: inline-block;
      transform-origin: left center;
      white-space: nowrap;
    }

    .content-text {
      color: #4d5460;
      font-size: 30px;
      transform: scale(0.5);
      display: inline-block;
      transform-origin: left center;
      white-space: nowrap;
    }
  }

  .submit-wrap {
    text-align: center;
    margin-top: 26px;

    .submit-btn {
      width: 300px;
      height: 45px;
      border-radius: 4px;
      font-size: 16px;
      font-weight: 600;
      background: #3f8eea;
      border-color: #3f8eea;
    }
  }
}
</style>
